<template>
  <div>
    <div class="  selectcard-hover items-center ">
      <!-- <p class="font-semibold text-sm mb-2">Category</p> -->
      <el-table
        class="table-responsive table-flush mt-6"
        header-row-class-name="thead-light table-th-color"
        :data="CategoryTagsData"
      >
        <el-table-column
          label="Category"
          prop="Category"
          min-width="120px"
          sortable
        >
          <template v-slot="{ row }">
            <span class=" text-black font-medium">{{ row.Category }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Commision Type"
          min-width="150px"
          prop="commissionType"
          sortable
        >
          <template v-slot="{ row }">
            <span class=" text-black font-medium">{{
              row.commissionType
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="Commission Fee"
          min-width="180px"
          prop="commissionFee"
          sortable
        >
          <template v-slot="{ row }">
            <span class=" text-black font-medium">{{ row.commissionFee }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import CategoryTagsData from "./CategoryTagsData";

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  data() {
    return {
      CategoryTagsData
    };
  }
};
</script>
